import React from 'react';
import ListView from "../components/List/BookingList";
import { useTranslation } from 'react-i18next';

export default function AllBookings() {
    const { t } = useTranslation();

    return (
        <div className="flex-1 flex flex-col min-h-0">
            <div className="flex items-center justify-between pb-4 shrink-0">
                <h2 className="text-xl sm:text-2xl font-bold font-gilroy text-[#1E293B] tracking-tight">
                    {t("adminBookings.title", "Bookings")}
                </h2>
            </div>
            <div className="bg-white flex-1 min-h-0 rounded-2xl border border-gray-100 overflow-hidden flex flex-col shadow-xs">
                <ListView />
            </div>
        </div>
    );
}
